export * from './tabs.service';

export * from './tabs.component';
export * from './tabs-container.component';

export * from './tabs.routes';

// export * from './tabs.module';